<template>

  <div>
    <v-text-field
      data-testid="dialog_resource__assumptions_input"
      :rules="[ isAssumpitonValid ]"
      :value="assumptions[index]"
      @change="this.onChange"
      outlined
      dense
      background-color="white"
      persistent-hint
      :placeholder="translate('ui_dialog_view_hint_input')"
    >
    </v-text-field>
    <div
      v-if="sampleDataEnabled"
    >
      <v-btn
        data-testid="dialog_resource_add__random-data_btn"
        @click="fillWithSampleData"
        color="blue-grey lighten-1"
        style="padding: 0 15px; min-width: initial; color: #fff;"
      >
        <v-icon style="width: 10px;">mdi-format-color-fill</v-icon>
      </v-btn>
      <div style="font-size: 12px; text-align: center;">
        {{ translate('ui_dialog_assumptions_random_data')}}
      </div>
    </div>
  </div>

</template>

<script>
// mixins
import Mixin from '../../../mixins/mixin';

export default {
  props: {
    assumptions: Array,
    index: Number,
    sampleDataEnabled: Boolean,
  },
  mixins: [Mixin],
  data: () => ({
    rules: [],
  }),
  computed: {
  },
  methods: {
    fillWithSampleData() {
      const numberOfPeriods = Number(this.$store.state.activeTemplate.layout.cFcstColCount);
      const sampleData = [];
      for (let i = 1; i < numberOfPeriods + 1; i++) {
        sampleData.push(100 * i);
      }
      // eslint-disable-next-line
      this.$emit('updateFlowAssumptions', this.index, sampleData.join(';'));
    },
    onChange(value) {
      const assumptionIndex = this.index;
      this.$emit('updateFlowAssumptions', assumptionIndex, value);
    },
  },
  mounted() {},
  updated() {},
};
</script>
